import styled from 'styled-components/macro';
import { MainBody } from 'components/text';
import { colors as Colors } from 'constants/colors';
export const LoginMessage = styled(MainBody).attrs(props => ({
  color: props.fail ? Colors.ERROR : 'green'
}))`
  color: ${props => props.color};
`;
